import auth from './auth';
import phone from './phone';
import call from './call';
import status from './status';
import callCurrent from './callCurrent';
import system from './system';
import contact from './contact';
import draft from './draft';
import tags from './tags';
import integrations from './integrations';
import afterCallWork from './afterCallWork';
import historyFilterOptions from './historyFilterOptions';
import dynamicQueues from './dynamicQueues';
import conversation from './conversation';
import accountInfo from './accountInfo';

const rootReducer = {
  auth,
  phone,
  call,
  status,
  callCurrent,
  system,
  contact,
  draft,
  tags,
  integrations,
  afterCallWork,
  historyFilterOptions,
  dynamicQueues,
  conversation,
  accountInfo,
};

export default rootReducer;
